import React from 'react'
import {Link} from 'react-scroll'
import { elementScrollIntoView } from "seamless-scroll-polyfill";

//import smoothscroll from 'smoothscroll-polyfill';
//onSetInactive
function SubmenuCategory() {


    
    

       function handle(id){
        //   polyfill()
        //   document.getElementById(id).scrollIntoView({behavior: "smooth", inline: "center"});

        elementScrollIntoView(document.getElementById(id), { behavior: "smooth", inline: "center" });
      }
    return (
                    <section className="submenu">
                        <div className="container flex" id="test">
                            <nav>
                                <ul>
                                    <li className="ahoj" id="category_1" key="category1"><Link activeClass="active" to="category1" smooth={true} duration={500} spy={true} exact="true" offset={-70} onSetActive={() => handle("category_1")}>category1</Link></li>
                                    <li className="ahoj" id="category_2" key="category2"><Link to="category2" smooth={true} duration={500} spy={true} exact="true" offset={-70} onSetActive={() => handle("category_2")}>category2</Link></li>
                                    <li className="ahoj" id="category_3" key="category3"><Link to="category3" smooth={true} duration={500} spy={true} exact="true" offset={-70} onSetActive={() => handle("category_3")}>category3</Link></li>
                                    <li className="ahoj" id="category_4" key="category4"><Link to="category4" smooth={true} duration={500} spy={true} exact="true" offset={-70} onSetActive={() => handle("category_4")}>category4</Link></li>
                                    <li className="ahoj" id="category_5" key="category5"><Link to="category5" smooth={true} duration={500} spy={true} exact="true" offset={-70} onSetActive={() => handle("category_5")}>category5</Link></li>
                                    <li className="ahoj" id="category_6" key="category6"><Link to="category6" smooth={true} duration={500} spy={true} exact="true" offset={-70} onSetActive={() => handle("category_6")}>category6</Link></li>
                                    <li className="ahoj" id="category_7" key="category7"><Link to="category7" smooth={true} duration={500} spy={true} exact="true" offset={-70} onSetActive={() => handle("category_7")}>category7</Link></li>
                                    <li className="ahoj" id="category_8" key="category8"><Link to="category8" smooth={true} duration={500} spy={true} exact="true" offset={-70} onSetActive={() => handle("category_8")}>category8</Link></li>
                                </ul>
                            </nav>
                        </div>
                    </section>

    )

}

export default SubmenuCategory
